module.exports = __webpack_public_path__ + "media/1x1/nf-801ee09f.svg";